import DailyStatistics from './DailyStatistics';

export default DailyStatistics;
